import React from 'react';
import {NewProjectProvider} from './utils/NewProjectContext';
import ProjectCreationWizard from './ProjectCreationWizard';

const ProjectCreationIndex = () => {
  return (
    <NewProjectProvider>
      <ProjectCreationWizard />
    </NewProjectProvider>
  );
};

export default ProjectCreationIndex;
